<template>
	<div class="main">
		<h1>Lista de resultados</h1>
		<br />

		<v-card class="rounded-lg result-card">
			<div class="before-table">
				<h1>Resultados</h1>
				<br />
				<v-switch
					inset
					label="Mostrar aceptados"
					color="info"
					v-model="options.accepted"
				></v-switch>
				<v-text-field
					v-model="userSearch"
					prepend-icon="mdi-magnify"
					label="Buscar por usuario"
					@change="fetchResults"
					@click:clear="clearSearch"
					clearable
				></v-text-field>
			</div>

			<v-data-table
				:headers="headers"
				:items="results"
				class="result-list-table"
				:items-per-page="20"
				:server-items-length="resultsCount"
				:page="1"
				:options.sync="options"
				:loading="loading"
				:footer-props="{
					itemsPerPageOptions: [1, 5, 10, 20],
					itemsPerPageText: 'Resultados por página',
					pageText: `${
						1 + options.itemsPerPage * (options.page - 1)
					}-${
						options.itemsPerPage * (options.page - 1) +
						results.length
					} de ${resultsCount}`,
					showFirstLastPage: true,
				}"
				:header-props="{
					sortByText: 'Ordenar por',
				}"
			>
				<template #no-data>No hay resultados</template>

				<template #item.accepted="{item}">
					<v-icon v-if="item.accepted" color="success">
						mdi-check
					</v-icon>
					<v-icon v-else color="error">
						mdi-close
					</v-icon>
				</template>

				<template #item.finishDate="{item}">
					{{ item.finishDate | formatDate }}
				</template>

				<template #item.score.distance="{item}">
					{{ item.score.distance | formatNumber }}m
				</template>

				<template #item.score.similarity="{item}">
					{{ (item.score.similarity * 100) | formatNumber }}%
				</template>

				<template #item.check="{item}">
					<v-btn
						elevation="0"
						class="rounded-lg"
						color="info"
						dark
						@click="openDialog(item)"
					>
						Comprobar
					</v-btn>
				</template>
			</v-data-table>
		</v-card>
		<v-dialog v-model="dialog" width="1000" class="accept-results">
			<template v-if="dialog">
				<v-card class="rounded-lg">
					<div class="pa-4">
						<h2>Revisión manual de ruta</h2>
						<span>
							<v-icon color="#ffcf00" class="leyend-icon"
								>mdi-square-rounded</v-icon
							>
							Ruta original
						</span>
						<br />
						<span>
							<v-icon color="#0099ff" class="leyend-icon"
								>mdi-square-rounded</v-icon
							>
							Ruta del usuario
						</span>
						<br />
						<span>
							<v-icon color="#ABCD76" class="leyend-icon"
								>mdi-square-rounded</v-icon
							>
							Coincide
						</span>
					</div>
					<race-map
						:route="selectedResult.originalRoute"
						:user-route="selectedResult.polyline | formatPolyline"
						v-if="selectedResult.originalRoute"
					></race-map>
					<div class="actions">
						<v-btn
							elevation="0"
							v-if="!selectedResult.accepted"
							@click="
								acceptResult(
									selectedResult.raceId,
									selectedResult.resultId
								)
							"
							class="rounded-lg"
							color="success"
						>
							Aceptar resultado
						</v-btn>
						<v-btn
							elevation="0"
							v-else
							@click="
								rejectResult(
									selectedResult.raceId,
									selectedResult.resultId
								)
							"
							class="rounded-lg"
							color="error"
						>
							Rechazar resultado
						</v-btn>
						<v-btn
							@click="dialog = false"
							text
							class="rounded-lg"
							color="error"
						>
							Cancelar
						</v-btn>
					</div>
				</v-card>
			</template>
		</v-dialog>
	</div>
</template>

<script>
	import moment from "moment";
	import axios from "axios";
	import googlePolyline from "google-polyline";

	import RaceMap from "../../components/admin/Map";
	export default {
		name: "ResultList",
		components: {
			RaceMap,
		},
		data: () => ({
			results: [],
			selectedResult: -1,
			options: {
				itemsPerPage: 20,
				page: 1,
				sortBy: ["name"],
				sortDesc: [true],
				accepted: false,
			},

			userSearch: null,

			resultsCount: 0,
			dialog: false,

			loading: false,

			headers: [
				{
					align: "center",
					text: "Usuario",
					value: "username",
				},
				{
					align: "center",
					text: "Aceptado",
					value: "accepted",
				},
				{
					align: "center",
					text: "Fecha finalización",
					value: "finishDate",
				},
				{
					align: "center",
					text: "Puntuación",
					value: "score.finalScore",
				},
				{
					align: "center",
					text: "Distancia con la ruta",
					value: "score.distance",
				},
				{
					align: "center",
					text: "Similitud de la ruta",
					value: "score.similarity",
				},
				{
					align: "center",
					text: "Comprobar",
					value: "check",
				},
			],
		}),
		filters: {
			formatNumber(val) {
				return Math.floor(val * 100) / 100;
			},
			formatPolyline(val) {
				return googlePolyline.decode(val);
			},
			formatDate(date) {
				if (date === "") {
					return "";
				} else {
					return moment(date).locale("es-ES").format("ll");
				}
			},
		},
		watch: {
			options: {
				deep: true,
				handler() {
					this.fetchResults();
				},
			},
		},
		methods: {
			openDialog(item) {
				this.selectedResult = item;
				this.dialog = true;
			},
			clearSearch() {
				this.userSearch = "";
				this.fetchResults();
			},
			async fetchResults() {
				try {
					this.loading = true;
					const response = await axios.get("/admin/races/results", {
						params: {
							page: this.options.page,
							perPage: this.options.itemsPerPage,
							orderBy: this.options.sortBy,
							sortDesc: this.options.sortDesc,
							accepted: this.options.accepted,
							userSearch: this.userSearch,
						},
					});
					this.results = response.data.results.map(
						(result) => result.result
					);
					this.resultsCount = response.data.resultsCount;
				} catch (error) {
					if (error.response && error.response.status === 401) {
						this.$router.push({ name: "AdminLogin" });
					} else {
						this.$emit("snackbar-event", {
							color: "error",
							text:
								"Ha ocurrido un error, vuelva a intentarlo más tarde",
						});
					}
				} finally {
					this.loading = false;
				}
			},

			async acceptResult(raceId, resultId) {
				try {
					this.loading = true;
					this.dialog = false;
					await axios.patch(
						`/admin/races/results/accept/${raceId}/${resultId}`
					);

					this.$emit("snackbar-event", {
						color: "success",
						text: "Se ha aceptado el resultado",
					});
				} catch (error) {
					console.log(error);
					this.$emit("snackbar-event", {
						color: "error",
						text: "No se ha podido aceptar el resultado",
					});
				} finally {
					this.loading = false;
					this.fetchResults();
				}
			},

			async rejectResult(raceId, resultId) {
				try {
					this.loading = true;
					this.dialog = false;
					await axios.patch(
						`/admin/races/results/reject/${raceId}/${resultId}`
					);

					this.$emit("snackbar-event", {
						color: "success",
						text: "Se ha rechazado el resultado",
					});
				} catch (error) {
					console.log(error);
					this.$emit("snackbar-event", {
						color: "error",
						text: "No se ha podido rechazar el resultado",
					});
				} finally {
					this.loading = false;
					this.fetchResults();
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.main {
		padding: 2em;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.result-card {
		max-width: 90%;
		.before-table {
			padding: 2em;

			.before-table-row {
				display: flex;
				flex-wrap: wrap;
			}
		}
	}
	.result-list {
		.v-expansion-panel-header {
			display: flex;
			flex-flow: row nowrap;
			align-items: center;

			p {
				margin: 0 0 0 1em;
			}
		}

		.v-expansion-panel-content {
			padding: 2em 0;
			background-color: #f0f0f0;
		}
	}

	.expanded {
		width: 100%;
		height: 480px;
	}
</style>

<style lang="scss">
	.result-list-table {
		&.v-data-table table tbody td {
			padding: 1em !important;
		}
	}

	.map {
		min-height: 350px;
		height: 70vh;
		max-height: 70vh;
	}

	.actions {
		padding: 0.5em 0;
		display: flex;
		flex-direction: row-reverse;
		flex-wrap: wrap;

		* {
			margin: 0.5em 0.5em;
		}
	}

	.v-dialog {
		transform: translateX(32px);
	}

	.leyend-icon {
		transform: translateY(-1px);
	}
</style>
